import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Search, X } from 'lucide-react';

// Comprehensive list of journalism topics (A-Z)
const PREDEFINED_TOPICS = [
  // A
  'Abortion Rights',
  'Accessibility',
  'Accounting',
  'Activism',
  'Addiction',
  'Advertising',
  'Aerospace',
  'Afghanistan',
  'Africa',
  'Agriculture',
  'AI Ethics',
  'Air Quality',
  'Airlines',
  'Alternative Energy',
  'Amazon',
  'Animal Rights',
  'Animation',
  'Antitrust',
  'Archaeology',
  'Architecture',
  'Arctic',
  'Arms Control',
  'Art',
  'Artificial Intelligence',
  'Asia',
  'Astronomy',
  'Athletics',
  'Automotive',
  'Aviation',
  
  // B
  'Banking',
  'Baseball',
  'Basketball',
  'Biodiversity',
  'Biotechnology',
  'Bitcoin',
  'Blockchain',
  'Books',
  'Border Security',
  'Boxing',
  'Breaking News',
  'Broadcasting',
  'Budget',
  'Business',
  'Business Ethics',
  
  // C
  'Campaign Finance',
  'Cancer Research',
  'Cannabis',
  'Capital Markets',
  'Carbon Emissions',
  'Celebrity News',
  'Censorship',
  'Central Banking',
  'Chemistry',
  'Child Welfare',
  'China',
  'Cinema',
  'Cities',
  'Civil Rights',
  'Climate Change',
  'Climate Science',
  'Colleges',
  'Comedy',
  'Communications',
  'Community',
  'Congress',
  'Conservation',
  'Constitution',
  'Consumer Protection',
  'Corporate Governance',
  'Corporate News',
  'Corruption',
  'Courts',
  'COVID-19',
  'Crime',
  'Criminal Justice',
  'Cryptocurrency',
  'Culture',
  'Cybersecurity',
  
  // D
  'Dance',
  'Data Privacy',
  'Data Science',
  'Defense',
  'Democracy',
  'Demographics',
  'Diabetes',
  'Digital Media',
  'Digital Rights',
  'Diplomacy',
  'Disability Rights',
  'Disasters',
  'Discrimination',
  'Disease',
  'Diversity',
  'Domestic Policy',
  'Drug Policy',
  'Drones',
  
  // E
  'E-commerce',
  'Earthquakes',
  'Ecology',
  'Economic Policy',
  'Economics',
  'Economy',
  'Education',
  'Educational Policy',
  'Elections',
  'Electric Vehicles',
  'Emergency Response',
  'Employment',
  'Energy',
  'Energy Markets',
  'Engineering',
  'Entertainment',
  'Entrepreneurship',
  'Environment',
  'Environmental Policy',
  'Epidemiology',
  'Ethics',
  'Europe',
  'Evolution',
  'Exercise',
  
  // F
  'Facebook',
  'Fact-Checking',
  'Family',
  'Fashion',
  'Federal Reserve',
  'Film',
  'Finance',
  'Financial Markets',
  'Firearms',
  'Fitness',
  'Floods',
  'Food',
  'Food Safety',
  'Football',
  'Foreign Policy',
  'Forests',
  'Fraud',
  'Free Speech',
  'Fundraising',
  
  // G
  'Gaming',
  'Gender Issues',
  'Genetics',
  'Geography',
  'Geology',
  'Geopolitics',
  'Global Health',
  'Global Warming',
  'Golf',
  'Google',
  'Government',
  'Gun Control',
  'Gun Violence',
  
  // H
  'Hacking',
  'Hardware',
  'Health',
  'Health Insurance',
  'Healthcare',
  'Higher Education',
  'History',
  'Hockey',
  'Home',
  'Homelessness',
  'Housing',
  'Human Rights',
  'Human Trafficking',
  'Hurricanes',
  
  // I
  'Immigration',
  'Immunology',
  'Inclusion',
  'India',
  'Indigenous Rights',
  'Industry',
  'Inequality',
  'Infrastructure',
  'Innovation',
  'Insurance',
  'Intelligence',
  'International Affairs',
  'International Trade',
  'Internet',
  'Investigative Reporting',
  'Investment',
  'Iran',
  'Iraq',
  'Israel',
  
  // J
  'Japan',
  'Jobs',
  'Journalism',
  'Justice',
  'Juvenile Justice',
  
  // K
  'K-12 Education',
  'Korea',
  
  // L
  'Labor',
  'Latin America',
  'Law',
  'Law Enforcement',
  'Legal System',
  'Legislation',
  'LGBTQ+',
  'Libraries',
  'Lifestyle',
  'Literature',
  'Local Government',
  'Local News',
  
  // M
  'Machine Learning',
  'Manufacturing',
  'Marine Biology',
  'Marketing',
  'Markets',
  'Marriage',
  'Media',
  'Medical Breakthroughs',
  'Medicine',
  'Mental Health',
  'Mergers',
  'Meteorology',
  'Mexico',
  'Middle East',
  'Military',
  'Mining',
  'Mobile Technology',
  'Movies',
  'Music',
  
  // N
  'NASA',
  'National News',
  'National Security',
  'Natural Disasters',
  'Natural Resources',
  'NATO',
  'Navy',
  'Neuroscience',
  'News',
  'Non-profit',
  'North Korea',
  'Nuclear Energy',
  'Nuclear Weapons',
  'Nutrition',
  
  // O
  'Obesity',
  'Oceans',
  'Oil',
  'Olympics',
  'Online Learning',
  'Op-Ed',
  'Opinion',
  'Opioids',
  'Organized Crime',
  
  // P
  'Palestine',
  'Pandemic',
  'Parenting',
  'Patents',
  'Personal Finance',
  'Pharmaceuticals',
  'Philosophy',
  'Photography',
  'Physics',
  'Podcasts',
  'Police',
  'Policy',
  'Political Analysis',
  'Politics',
  'Pollution',
  'Pop Culture',
  'Poverty',
  'Press Freedom',
  'Privacy',
  'Professional Sports',
  'Psychology',
  'Public Administration',
  'Public Health',
  'Public Safety',
  'Public Transit',
  
  // Q
  'Quantum Computing',
  
  // R
  'Race Relations',
  'Radio',
  'Real Estate',
  'Refugees',
  'Religion',
  'Renewable Energy',
  'Reproductive Rights',
  'Research',
  'Retail',
  'Retirement',
  'Robotics',
  'Russia',
  
  // S
  'Safety',
  'Science',
  'Security',
  'Semiconductors',
  'Sexual Assault',
  'Shipping',
  'Social Issues',
  'Social Media',
  'Soccer',
  'Society',
  'Software',
  'Solar Energy',
  'Space',
  'Sports',
  'Sports Business',
  'Startups',
  'Stock Market',
  'Streaming',
  'Student Life',
  'Supreme Court',
  'Surgery',
  'Surveillance',
  'Sustainability',
  
  // T
  'Taxes',
  'Technology',
  'Telecommunications',
  'Television',
  'Tennis',
  'Terrorism',
  'Theater',
  'Tourism',
  'Trade',
  'Traffic',
  'Transportation',
  'Travel',
  'Twitter',
  
  // U
  'Ukraine',
  'Unemployment',
  'United Nations',
  'Universities',
  'Urban Planning',
  'US Politics',
  
  // V
  'Vaccines',
  'Veterans',
  'Video Games',
  'Virtual Reality',
  'Voting',
  'Voting Rights',
  
  // W
  'War',
  'Water',
  'Wealth',
  'Weather',
  'Web Development',
  'Welfare',
  'Wildlife',
  'Wind Energy',
  'Women\'s Rights',
  'Work',
  'World News',
  
  // X, Y, Z
  'Youth',
  'Zoning'
].sort();

interface TopicSelectProps {
  value: string;
  onChange: (topic: string) => void;
}

const TopicSelect: React.FC<TopicSelectProps> = ({ value, onChange }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  // Filter topics based on search query
  const filteredTopics = PREDEFINED_TOPICS.filter(topic =>
    topic.toLowerCase().includes(searchQuery.toLowerCase())
  ).slice(0, 10); // Limit to 10 results for performance

  // Handle clicking outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
        setSelectedIndex(-1);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!showDropdown) return;

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          setSelectedIndex(prev => 
            prev < filteredTopics.length - 1 ? prev + 1 : prev
          );
          break;
        case 'ArrowUp':
          event.preventDefault();
          setSelectedIndex(prev => prev > 0 ? prev - 1 : -1);
          break;
        case 'Enter':
          event.preventDefault();
          if (selectedIndex >= 0 && selectedIndex < filteredTopics.length) {
            handleSelect(filteredTopics[selectedIndex]);
          } else if (searchQuery.trim()) {
            handleSelect(searchQuery.trim());
          }
          break;
        case 'Escape':
          setShowDropdown(false);
          setSelectedIndex(-1);
          inputRef.current?.blur();
          break;
      }
    };

    if (showDropdown) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [showDropdown, selectedIndex, filteredTopics, searchQuery]);

  const handleSelect = (topicName: string) => {
    onChange(topicName);
    setSearchQuery('');
    setShowDropdown(false);
    setSelectedIndex(-1);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchQuery(newValue);
    setShowDropdown(true);
    setSelectedIndex(-1);
    
    // If input is cleared, clear the selected topic
    if (newValue.trim() === '') {
      onChange('');
    }
  };

  const handleInputFocus = () => {
    setShowDropdown(true);
    setSearchQuery(value || '');
  };

  const clearSelection = () => {
    onChange('');
    setSearchQuery('');
    setShowDropdown(false);
    inputRef.current?.focus();
  };

  const displayValue = value || searchQuery;

  return (
    <div className="relative" ref={dropdownRef}>
      <label htmlFor="topic" className="block text-sm font-medium text-gray-400 mb-2">
        Topic *
      </label>
      
      <div className="relative">
        <div className="relative">
          <input
            ref={inputRef}
            type="text"
            id="topic"
            value={displayValue}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            placeholder="Search for a topic..."
            className="w-full px-4 py-3 pr-20 bg-[#272727] text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 border border-[#404040] hover:border-[#505050] transition-colors"
            autoComplete="off"
          />
          
          <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center space-x-1">
            {value && (
              <button
                type="button"
                onClick={clearSelection}
                className="text-gray-400 hover:text-white transition-colors p-1"
                aria-label="Clear selection"
              >
                <X className="h-4 w-4" />
              </button>
            )}
            <div className="text-gray-400">
              {showDropdown ? (
                <ChevronDown className="h-4 w-4 rotate-180 transition-transform" />
              ) : (
                <ChevronDown className="h-4 w-4 transition-transform" />
              )}
            </div>
          </div>
        </div>

        {showDropdown && (
          <div className="absolute z-20 w-full mt-1 bg-[#272727] rounded-lg shadow-lg border border-[#404040] max-h-60 overflow-auto">
            {filteredTopics.length > 0 ? (
              <>
                {filteredTopics.map((topic, index) => (
                  <button
                    key={topic}
                    type="button"
                    onClick={() => handleSelect(topic)}
                    className={`w-full px-4 py-3 text-left hover:bg-[#404040] text-white text-sm transition-colors flex items-center justify-between ${
                      index === selectedIndex ? 'bg-[#404040]' : ''
                    }`}
                  >
                    <span>{topic}</span>
                    {value === topic && (
                      <div className="w-2 h-2 bg-purple-500 rounded-full" />
                    )}
                  </button>
                ))}
                
                {/* Option to create custom topic if search doesn't match exactly */}
                {searchQuery && 
                 !filteredTopics.some(t => t.toLowerCase() === searchQuery.toLowerCase()) && (
                  <button
                    type="button"
                    onClick={() => handleSelect(searchQuery)}
                    className={`w-full px-4 py-3 text-left hover:bg-[#404040] text-purple-400 text-sm transition-colors border-t border-[#404040] ${
                      selectedIndex === filteredTopics.length ? 'bg-[#404040]' : ''
                    }`}
                  >
                    <div className="flex items-center">
                      <Search className="h-4 w-4 mr-2" />
                      <span>Create "{searchQuery}"</span>
                    </div>
                  </button>
                )}
              </>
            ) : searchQuery ? (
              <button
                type="button"
                onClick={() => handleSelect(searchQuery)}
                className="w-full px-4 py-3 text-left hover:bg-[#404040] text-purple-400 text-sm transition-colors"
              >
                <div className="flex items-center">
                  <Search className="h-4 w-4 mr-2" />
                  <span>Create "{searchQuery}"</span>
                </div>
              </button>
            ) : (
              <div className="px-4 py-3 text-gray-500 text-sm">
                Start typing to search topics...
              </div>
            )}
          </div>
        )}
      </div>
      
      {!value && (
        <p className="mt-1 text-xs text-gray-500">
          Select from existing topics or create a new one
        </p>
      )}
    </div>
  );
};

export default TopicSelect;